var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 55,
    viewBox: "0 0 195 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187.778 55H7.22222C3.25181 55 0 51.9045 0 48.125V6.875C0 3.09547 3.25181 0 7.22222 0H187.778C191.748 0 195 3.09547 195 6.875V48.125C195 51.9045 191.748 55 187.778 55Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M187.778 1.10172C191.122 1.10172 193.843 3.69187 193.843 6.875V48.125C193.843 51.3081 191.122 53.8983 187.778 53.8983H7.22222C3.87833 53.8983 1.15736 51.3081 1.15736 48.125V6.875C1.15736 3.69187 3.87833 1.10172 7.22222 1.10172H187.778ZM187.778 0H7.22222C3.25181 0 0 3.09547 0 6.875V48.125C0 51.9045 3.25181 55 7.22222 55H187.778C191.748 55 195 51.9045 195 48.125V6.875C195 3.09547 191.748 0 187.778 0Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0727 10.3662C14.6484 10.7891 14.4028 11.4473 14.4028 12.2998V42.708C14.4028 43.5605 14.6484 44.2187 15.0727 44.6416L15.1774 44.7344L33.0777 27.7016V27.2994L15.1774 10.2666L15.0727 10.3662Z",
    fill: "url(#paint0_linear_339_14513)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0378 33.3809L33.0776 27.7004V27.2982L39.045 21.6177L39.1786 21.6916L46.2456 25.5193C48.2624 26.6055 48.2624 28.393 46.2456 29.4862L39.1786 33.307L39.0378 33.3809Z",
    fill: "url(#paint1_linear_339_14513)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1787 33.3072L33.0778 27.4995L15.0728 44.6406C15.7426 45.3109 16.835 45.3917 18.0772 44.7214L39.1787 33.3072Z",
    fill: "url(#paint2_linear_339_14513)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1787 21.6923L18.0772 10.2781C16.835 9.61469 15.7426 9.69547 15.0728 10.3658L33.0778 27.5L39.1787 21.6923Z",
    fill: "url(#paint3_linear_339_14513)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.492 14.0852C68.492 15.2334 68.1309 16.1529 67.4195 16.8387C66.6016 17.6516 65.5363 18.0607 64.2309 18.0607C62.9833 18.0607 61.918 17.6448 61.0441 16.8249C60.1684 15.993 59.7314 14.9721 59.7314 13.7501C59.7314 12.528 60.1684 11.5071 61.0441 10.6821C61.918 9.85539 62.9833 9.43945 64.2309 9.43945C64.852 9.43945 65.4442 9.56148 66.0094 9.78836C66.5727 10.017 67.0313 10.3263 67.3635 10.7079L66.6088 11.4332C66.0292 10.7818 65.2402 10.4604 64.2309 10.4604C63.3209 10.4604 62.5319 10.7629 61.862 11.373C61.1994 11.9849 60.8671 12.7773 60.8671 13.7501C60.8671 14.7229 61.1994 15.5221 61.862 16.134C62.5319 16.7373 63.3209 17.0466 64.2309 17.0466C65.1969 17.0466 66.0094 16.7373 66.6503 16.1271C67.0728 15.7232 67.313 15.1663 67.3762 14.4548H64.2309V13.4613H68.427C68.4776 13.6762 68.492 13.8841 68.492 14.0852Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1492 10.6412H71.2076V13.2537H74.761V14.2472H71.2076V16.8597H75.1492V17.872H70.0918V9.62891H75.1492V10.6412Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8472 17.872H78.7314V10.6412H76.3137V9.62891H82.2666V10.6412H79.8472V17.872Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5747 17.872V9.62891H87.6887V17.872H86.5747Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6267 17.872H91.5199V10.6412H89.0933V9.62891H95.0534V10.6412H92.6267V17.872Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M106.324 16.8112C105.47 17.6448 104.412 18.0607 103.15 18.0607C101.88 18.0607 100.822 17.6448 99.9682 16.8112C99.116 15.9793 98.6917 14.9584 98.6917 13.7501C98.6917 12.5418 99.116 11.5209 99.9682 10.689C100.822 9.85539 101.88 9.43945 103.15 9.43945C104.404 9.43945 105.462 9.85539 106.317 10.6959C107.176 11.5346 107.6 12.5487 107.6 13.7501C107.6 14.9584 107.176 15.9793 106.324 16.8112ZM100.793 16.1202C101.436 16.7373 102.218 17.0466 103.15 17.0466C104.074 17.0466 104.863 16.7373 105.499 16.1202C106.14 15.5032 106.465 14.7109 106.465 13.7501C106.465 12.7893 106.14 11.997 105.499 11.3799C104.863 10.7629 104.074 10.4535 103.15 10.4535C102.218 10.4535 101.436 10.7629 100.793 11.3799C100.152 11.997 99.8273 12.7893 99.8273 13.7501C99.8273 14.7109 100.152 15.5032 100.793 16.1202Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M109.166 17.872V9.62891H110.52L114.73 16.0398H114.779L114.73 14.4552V9.62891H115.845V17.872H114.682L110.273 11.1448H110.224L110.273 12.7364V17.872H109.166Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4172 29.9106C95.0246 29.9106 92.2531 32.3684 92.2531 35.7595C92.2531 39.123 95.0246 41.6066 98.4172 41.6066C101.817 41.6066 104.589 39.123 104.589 35.7595C104.589 32.3684 101.817 29.9106 98.4172 29.9106ZM98.4172 39.3035C96.5557 39.3035 94.9542 37.8409 94.9542 35.7595C94.9542 33.6506 96.5557 32.2137 98.4172 32.2137C100.279 32.2137 101.888 33.6506 101.888 35.7595C101.888 37.8409 100.279 39.3035 98.4172 39.3035ZM84.9677 29.9106C81.5678 29.9106 78.8035 32.3684 78.8035 35.7595C78.8035 39.123 81.5678 41.6066 84.9677 41.6066C88.3657 41.6066 91.1318 39.123 91.1318 35.7595C91.1318 32.3684 88.3657 29.9106 84.9677 29.9106ZM84.9677 39.3035C83.1043 39.3035 81.4974 37.8409 81.4974 35.7595C81.4974 33.6506 83.1043 32.2137 84.9677 32.2137C86.8292 32.2137 88.4307 33.6506 88.4307 35.7595C88.4307 37.8409 86.8292 39.3035 84.9677 39.3035ZM68.9632 31.7032V34.1885H75.1978C75.0154 35.5773 74.5279 36.5982 73.7804 37.3098C72.8704 38.1691 71.4531 39.123 68.9632 39.123C65.1264 39.123 62.122 36.1754 62.122 32.5231C62.122 28.8707 65.1264 25.9231 68.9632 25.9231C71.0378 25.9231 72.5472 26.6948 73.6613 27.6951L75.5011 25.9437C73.9429 24.5274 71.8702 23.4395 68.9632 23.4395C63.7018 23.4395 59.28 27.5146 59.28 32.5231C59.28 37.5315 63.7018 41.6066 68.9632 41.6066C71.807 41.6066 73.9429 40.7198 75.6221 39.056C77.3428 37.418 77.879 35.1149 77.879 33.2552C77.879 32.6777 77.8285 32.1466 77.7382 31.7032H68.9632ZM134.407 33.6299C133.9 32.322 132.335 29.9106 129.146 29.9106C125.986 29.9106 123.356 32.2807 123.356 35.7595C123.356 39.0354 125.959 41.6066 129.449 41.6066C132.271 41.6066 133.9 39.9687 134.57 39.0148L132.475 37.6862C131.777 38.659 130.825 39.3035 129.449 39.3035C128.083 39.3035 127.102 38.7071 126.474 37.5315L134.691 34.2951L134.407 33.6299ZM126.03 35.5773C125.959 33.3223 127.869 32.1673 129.238 32.1673C130.311 32.1673 131.221 32.6777 131.524 33.4082L126.03 35.5773ZM119.351 41.2509H122.052V24.0634H119.351V41.2509ZM114.927 31.2134H114.837C114.23 30.5293 113.073 29.9106 111.607 29.9106C108.53 29.9106 105.717 32.4818 105.717 35.7784C105.717 39.056 108.53 41.6066 111.607 41.6066C113.073 41.6066 114.23 40.9827 114.837 40.278H114.927V41.1168C114.927 43.3529 113.672 44.5543 111.648 44.5543C109.998 44.5543 108.974 43.4199 108.552 42.466L106.203 43.3993C106.88 44.9496 108.673 46.8574 111.648 46.8574C114.815 46.8574 117.488 45.0837 117.488 40.7679V30.2663H114.927V31.2134ZM111.838 39.3035C109.976 39.3035 108.418 37.8202 108.418 35.7784C108.418 33.7176 109.976 32.2137 111.838 32.2137C113.672 32.2137 115.119 33.7176 115.119 35.7784C115.119 37.8202 113.672 39.3035 111.838 39.3035ZM147.053 24.0634H140.593V41.2509H143.287V34.7385H147.053C150.045 34.7385 152.979 32.6777 152.979 29.4001C152.979 26.1241 150.038 24.0634 147.053 24.0634ZM147.124 32.3477H143.287V26.4541H147.124C149.135 26.4541 150.284 28.044 150.284 29.4001C150.284 30.7304 149.135 32.3477 147.124 32.3477ZM163.777 29.8779C161.83 29.8779 159.806 30.696 158.974 32.5093L161.364 33.4632C161.879 32.5093 162.825 32.1999 163.825 32.1999C165.223 32.1999 166.64 32.9991 166.662 34.4102V34.5907C166.174 34.3226 165.131 33.9256 163.847 33.9256C161.272 33.9256 158.649 35.2748 158.649 37.7927C158.649 40.0959 160.758 41.5791 163.128 41.5791C164.941 41.5791 165.941 40.8005 166.57 39.8948H166.662V41.2234H169.264V34.6302C169.264 31.5829 166.873 29.8779 163.777 29.8779ZM163.452 39.2966C162.57 39.2966 161.343 38.8807 161.343 37.8409C161.343 36.5106 162.874 36.0001 164.199 36.0001C165.385 36.0001 165.941 36.2493 166.662 36.5776C166.451 38.1691 165.012 39.2966 163.452 39.2966ZM178.743 30.2543L175.646 37.7051H175.554L172.353 30.2543H169.448L174.258 40.6665L171.513 46.4604H174.328L181.74 30.2543H178.743ZM154.46 41.2509H157.161V24.0634H154.46V41.2509Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_339_14513",
    x1: 31.4884,
    y1: 43.0246,
    x2: 8.44054,
    y2: 18.8128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_339_14513",
    x1: 48.8718,
    y1: 27.4974,
    x2: 13.9207,
    y2: 27.4974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_339_14513",
    x1: 35.8612,
    y1: 24.3424,
    x2: 4.60648,
    y2: -8.49086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_339_14513",
    x1: 10.5405,
    y1: 54.7577,
    x2: 24.4972,
    y2: 40.0963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.26d36f48aeb392f3e057cc9aca649b43.svg";
export { ForwardRef as ReactComponent };